import { useMediaQuery } from '../utils/style';
import { useTheme } from '../utils/theme';
import type { Breakpoint } from '../utils/types';

export const useIsSmallScreen = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

export const useIsScreenSmallerThan = (breakpoint: Breakpoint) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
